import { render, staticRenderFns } from "./setDrawer.vue?vue&type=template&id=0843f326&scoped=true"
import script from "./setDrawer.vue?vue&type=script&lang=js"
export * from "./setDrawer.vue?vue&type=script&lang=js"
import style0 from "./setDrawer.vue?vue&type=style&index=0&id=0843f326&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0843f326",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\work\\git-new\\ai-business-web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0843f326')) {
      api.createRecord('0843f326', component.options)
    } else {
      api.reload('0843f326', component.options)
    }
    module.hot.accept("./setDrawer.vue?vue&type=template&id=0843f326&scoped=true", function () {
      api.rerender('0843f326', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/clue/components/setDrawer.vue"
export default component.exports